import {
  CHANGE_PASSWORD_REQUEST,
  CHANGE_COMPANY_PASSWORD_REQUEST,
  CHANGE_CLIENT_PASSWORD_REQUEST,
  CHANGE_PASSWORD_SETTLED,
  LOGIN_REQUEST,
  LOGIN_RESPONSE,
  LOGOUT_REQUEST,
  FORGET_PASSWORD_REQUEST,
  GET_PERMISSION_REQUEST,
  GET_PERMISSION_RESPONSE,
} from "./types";

export const loginRequest = (payload) => ({
  type: LOGIN_REQUEST,
  payload,
});

export const loginResponse = (payload) => ({
  type: LOGIN_RESPONSE,
  payload,
});

export const logoutRequest = (payload) => ({
  type: LOGOUT_REQUEST,
  payload,
});

export const changePasswordRequest = (payload) => ({
  type: CHANGE_PASSWORD_REQUEST,
  payload,
});

export const changeCompanyPasswordRequest = (payload) => ({
  type: CHANGE_COMPANY_PASSWORD_REQUEST,
  payload,
});

export const changeClientPasswordRequest = (payload) => ({
  type: CHANGE_CLIENT_PASSWORD_REQUEST,
  payload,
});

export const changePasswordSettled = () => ({
  type: CHANGE_PASSWORD_SETTLED,
});

export const forgetPasswordRequest = (payload) => ({
  type: FORGET_PASSWORD_REQUEST,
  payload,
});

export const getPermissionRequest = (payload) => ({
  type: GET_PERMISSION_REQUEST,
  payload,
});

export const getPermissionResponse = (payload) => ({
  type: GET_PERMISSION_RESPONSE,
  payload,
});
